import * as React from 'react'
import { Tag, Intent } from '@blueprintjs/core'
import { isFuture } from '../../../utils/dateHelpers'
import InteractiveDatetime from '../../../components/InteractiveDatetime'

interface Props {
  startTime: Date
}

const StartTime: React.FC<Props> = ({ startTime }) => {
  const isScheduled = startTime && isFuture(startTime)
  return (
    <>
      {isScheduled && (
        <Tag style={{ marginRight: 5 }} minimal intent={Intent.WARNING} title="Scheduled">
          Scheduled
        </Tag>
      )}
      <InteractiveDatetime value={startTime} />
    </>
  )
}

export { StartTime }
